import { g as r } from "../../utils-BOfnFgIH.js";
import { I as p } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as f, normalizeClass as n, createElementVNode as t, createStaticVNode as a } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDpmLogo",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (s) => Object.keys(p).includes(s)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return p[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], m = ["fill"], h = ["fill"], D = ["id"], F = ["id"];
function g(s, o, i, v, _, e) {
  return l(), f("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--dpm-logo"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Dpm Logo",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    o[2] || (o[2] = t("rect", {
      width: "24",
      height: "24",
      rx: "3.6",
      fill: "#F2F0EE"
    }, null, -1)),
    t("path", {
      d: "M17.054 13.57v-3.216c0-.294.158-.565.414-.71l1.84-1.047a.818.818 0 0 1 1.223.71v5.345a.818.818 0 0 1-1.233.705l-1.84-1.082a.818.818 0 0 1-.404-.706Z",
      fill: `url(#${s.uniqueID}a)`
    }, null, 8, m),
    o[3] || (o[3] = t("path", {
      d: "M14.407 5.563a3 3 0 0 1 3.001 3v6.828c0 1.656-1.344 3-3 3H7.562a3 3 0 0 1-3-3V8.562a3 3 0 0 1 3-3h6.844Zm-.69 4.22v2.31c-.234-.357-.758-.632-1.308-.632-1.183 0-2.034.94-2.034 2.236 0 1.297.85 2.244 2.034 2.244.55 0 1.074-.283 1.308-.64v.557h.967V9.782h-.967Zm-1.15 2.518c.625 0 1.091.457 1.15 1.113v.549c-.059.657-.525 1.139-1.15 1.139-.7 0-1.2-.582-1.2-1.414 0-.83.5-1.387 1.2-1.387Zm-3.05-4.615c-.01-.068-.13-.085-.155-.021-.398 1.228-1.26 2.189-2.408 2.657-.056.027-.045.12.015.135.904.217 1.605 1.022 1.762 2.03.011.065.12.08.146.018.46-1.285 1.34-2.25 2.457-2.627.058-.026.045-.127-.017-.14-.925-.206-1.645-1.025-1.8-2.052Z",
      fill: "#10022C"
    }, null, -1)),
    t("path", {
      d: "M14.407 5.563a3 3 0 0 1 3.001 3v6.828c0 1.656-1.344 3-3 3H7.562a3 3 0 0 1-3-3V8.562a3 3 0 0 1 3-3h6.844Zm-.69 4.22v2.31c-.234-.357-.758-.632-1.308-.632-1.183 0-2.034.94-2.034 2.236 0 1.297.85 2.244 2.034 2.244.55 0 1.074-.283 1.308-.64v.557h.967V9.782h-.967Zm-1.15 2.518c.625 0 1.091.457 1.15 1.113v.549c-.059.657-.525 1.139-1.15 1.139-.7 0-1.2-.582-1.2-1.414 0-.83.5-1.387 1.2-1.387Zm-3.05-4.615c-.01-.068-.13-.085-.155-.021-.398 1.228-1.26 2.189-2.408 2.657-.056.027-.045.12.015.135.904.217 1.605 1.022 1.762 2.03.011.065.12.08.146.018.46-1.285 1.34-2.25 2.457-2.627.058-.026.045-.127-.017-.14-.925-.206-1.645-1.025-1.8-2.052Z",
      fill: `url(#${s.uniqueID}b)`
    }, null, 8, h),
    t("defs", null, [
      t("linearGradient", {
        id: `${s.uniqueID}a`,
        x1: "10.987",
        y1: "2.72",
        x2: "23.248",
        y2: "4.266",
        gradientUnits: "userSpaceOnUse"
      }, [...o[0] || (o[0] = [
        a('<stop offset=".06" stop-color="#10022C"></stop><stop offset=".2" stop-color="#611F93"></stop><stop offset=".29" stop-color="#8223A1"></stop><stop offset=".366" stop-color="#9325A5"></stop><stop offset=".459" stop-color="#C52599" stop-opacity=".9"></stop><stop offset=".564" stop-color="#D52C86"></stop><stop offset=".658" stop-color="#EA2F6F"></stop><stop offset=".737" stop-color="#F64850"></stop><stop offset=".896" stop-color="#FD6D2D"></stop><stop offset=".955" stop-color="#FF9E0E" stop-opacity=".95"></stop>', 10)
      ])], 8, D),
      t("linearGradient", {
        id: `${s.uniqueID}b`,
        x1: "2.555",
        y1: "2.796",
        x2: "17.788",
        y2: "18.411",
        gradientUnits: "userSpaceOnUse"
      }, [...o[1] || (o[1] = [
        a('<stop offset=".06" stop-color="#10022C"></stop><stop offset=".2" stop-color="#611F93"></stop><stop offset=".29" stop-color="#8223A1"></stop><stop offset=".366" stop-color="#9325A5"></stop><stop offset=".459" stop-color="#C52599" stop-opacity=".9"></stop><stop offset=".564" stop-color="#D52C86"></stop><stop offset=".658" stop-color="#EA2F6F"></stop><stop offset=".737" stop-color="#F64850"></stop><stop offset=".896" stop-color="#FD6D2D"></stop><stop offset=".955" stop-color="#FF9E0E" stop-opacity=".95"></stop>', 10)
      ])], 8, F)
    ])
  ], 10, u);
}
const S = /* @__PURE__ */ d(c, [["render", g]]);
export {
  S as default
};
//# sourceMappingURL=dpm-logo.js.map
